import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="The-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M42,38.0031611 C42,40.2105543 40.2147544,42 38.0098214,42 L9.99017859,42 C7.7864638,42 6,40.2058797 6,38.0031611 L6,18 C4.89421792,18 4,17.0980496 4,15.9914698 L4,9.99582624 C4,7.78899235 5.79642476,6 8.00002553,6 L39.9999745,6 C42.2091276,6 44,7.79652125 44,9.99582624 L44,15.9914698 C44,17.1007504 43.1084602,18 42.0027084,18 L42,38.0031611 Z M10,18 L10,38 L38,38 L38,18 L10,18 Z M8,10 L8,14 L40,14 L40,10 L8,10 Z M16,24 C16,22.8954305 16.8945138,22 17.9940603,22 L30.0059397,22 C31.1072288,22 32,22.8877296 32,24 C32,25.1045695 31.1054862,26 30.0059397,26 L17.9940603,26 C16.8927712,26 16,25.1122704 16,24 Z" id="Combined-Shape" fill={color}></path>
        </g>
    </svg>
)

export default class IconArchive extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
